import { render } from "./MoreDetailsRoster17Screen.vue?vue&type=template&id=6f76d124&scoped=true"
import script from "./MoreDetailsRoster17Screen.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster17Screen.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster17Screen.vue?vue&type=style&index=0&id=6f76d124&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f76d124"]])

export default __exports__